import React from 'react';
import logo from './logo.svg';
import './App.scss';
import {Outlet} from "react-router-dom";
import { Toaster } from 'react-hot-toast';

function App() {
  return (
      <div id="App">
        <Outlet/>
        <Toaster />
      </div>
  );
}

export default App;
